import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { PlatformAdminListItem } from '../../../+state/platform-admins/platform-admins.models';
import { environment } from '../../../../environments/environment';

/**
 * HTTP access to the platform-admin management endpoints. The platform-auth
 * interceptor attaches the Bearer token + `x-cdw-app-name`, so no headers are
 * set here.
 */
@Injectable({ providedIn: 'root' })
export class PlatformAdminsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.urls.backendApi}/platform/admins`;

  list(): Observable<PlatformAdminListItem[]> {
    return this.http.get<PlatformAdminListItem[]>(this.baseUrl);
  }

  add(
    email: string,
    name: string,
    isSuper = false
  ): Observable<PlatformAdminListItem> {
    return this.http.post<PlatformAdminListItem>(this.baseUrl, {
      email,
      name,
      isSuper,
    });
  }

  remove(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
